(() => {
  const root = document.querySelector('[data-ww-bedtime]');
  if (!root) return;

  const form = root.querySelector('form');
  const input = root.querySelector('input[type="time"]');
  const output = root.querySelector('[data-ww-bedtime-output]');
  const nowButton = root.querySelector('[data-ww-now]');

  const format = (date) => date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
  const renderForWake = (hours, minutes) => {
    const wake = new Date();
    wake.setHours(hours, minutes, 0, 0);
    const times = [6, 5, 4].map((cycles) => {
      const time = new Date(wake.getTime() - ((cycles * 90 + 15) * 60000));
      return `<li><strong>${format(time)}</strong><span>${cycles} cycles</span></li>`;
    });
    output.innerHTML = `<p>Allowing 15 minutes to fall asleep:</p><ul>${times.join('')}</ul><p class="ww-note">Sleep cycles vary. These are planning times, not a medical recommendation.</p>`;
  };

  form?.addEventListener('submit', (event) => {
    event.preventDefault();
    if (!input.value) return;
    const [hours, minutes] = input.value.split(':').map(Number);
    renderForWake(hours, minutes);
  });

  nowButton?.addEventListener('click', () => {
    const now = new Date();
    const times = [4, 5, 6].map((cycles) => {
      const time = new Date(now.getTime() + ((cycles * 90 + 15) * 60000));
      return `<li><strong>${format(time)}</strong><span>${cycles} cycles</span></li>`;
    });
    output.innerHTML = `<p>If the lamp goes off now:</p><ul>${times.join('')}</ul><p class="ww-note">Sleep cycles vary. These are planning times, not a medical recommendation.</p>`;
  });
})();
